module.exports = __webpack_public_path__ + "static/media/combined-shape.80ffc998.svg";